import { useMutation } from "@tanstack/react-query";

import { logger } from "#app/monitoring/Logger";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { createCompanyApi, CreateCompanyDto } from "#modules/company/infra/createCompany.api";

type Option = {
  onSuccess?: () => void;
};

export const useCreateCompany = (options?: Option) => {
  const { mutate, ...rest } = useMutation({
    mutationFn: async (data: CreateCompanyDto) => await createCompanyApi(data),
    async onSuccess() {
      showSuccessToast({
        title: "Companie crée avec succès",
        message: "Veuillez vous reconnecter pour terminer l'inscription",
      });
      options?.onSuccess?.();
    },
    onError(err) {
      logger.error(err);
      showErrorToast({
        title: "Erreur est survenue",
        message: "Erreur est survenue lors de la création de la companie",
      });
    },
  });

  return { createCompany: mutate, ...rest };
};
